var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKatalon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 94,
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6cb645",
    d: "M60.05 24h17.216v45.913H60.05z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.614 46.975L77.253 24H60.05l22.963 36.75zm1.434 2.295l-8.602 13.775 4.288 6.856h17.216z",
    fill: "#00a1df"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9aca3c",
    d: "M60.05 69.9h17.203L105.95 24H88.734z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKatalon);
export default __webpack_public_path__ + "static/media/Katalon.771245f30f360de0fec0213a7b31ffb4.svg";
export { ForwardRef as ReactComponent };